// app/javascript/controllers/character_counter_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "counter"]
  static values = {
    maxLength: Number,
    warningThreshold: { type: Number, default: 0 }
  }

  connect() {
    this.updateCounter()
  }

  updateCounter() {
    const currentLength = this.inputTarget.value.length
    this.counterTarget.textContent = `${currentLength}/${this.maxLengthValue}`

    // Add warning styling when approaching the limit
    if (this.warningThresholdValue > 0 &&
        currentLength >= (this.maxLengthValue - this.warningThresholdValue)) {
      this.counterTarget.classList.add("text-yellow-600")
    } else {
      this.counterTarget.classList.remove("text-yellow-600")
    }

    // Add error styling when over the limit
    if (currentLength > this.maxLengthValue) {
      this.counterTarget.classList.add("text-red-600")
    } else {
      this.counterTarget.classList.remove("text-red-600")
    }
  }
}